import React, {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';

import service from '@/services/index';

interface Props {
  alias: string;
  setSize: Dispatch<SetStateAction<[number, number] | null>>;
  setDuration: Dispatch<SetStateAction<number | null>>;
  setFileSize: Dispatch<SetStateAction<number | null>>;
}

const VideoViewer = ({ alias, setSize, setDuration, setFileSize }: Props) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [url, setUrl] = useState<string>('');

  const onLoadedMetadata = () => {
    if (videoRef && videoRef.current) {
      setSize([videoRef.current.videoWidth, videoRef.current.videoHeight]);
      setDuration(videoRef.current.duration);
    }
  };

  useEffect(() => {
    service.attachment.getAttachment(alias, 'video').then((data) => {
      const fileUrl = URL.createObjectURL(data);
      setUrl(fileUrl);
      if (videoRef.current) {
        videoRef.current.src = fileUrl;
      }
    });

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [alias, videoRef]);

  return (
    <Video
      ref={videoRef}
      controls
      preload="metadata"
      playsInline
      controlsList="nodownload"
      onLoadedMetadata={onLoadedMetadata}
    ></Video>
  );
};

const Video = styled.video`
  height: 80%;
`;

export default VideoViewer;
